var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 204,
    viewBox: "0 0 205 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 204,
    height: 204,
    rx: 100,
    fill: "#F8FAFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 53.3477V74.0004C112.5 76.8006 112.5 78.2007 113.045 79.2703C113.524 80.2111 114.289 80.976 115.23 81.4554C116.3 82.0004 117.7 82.0004 120.5 82.0004H141.153M91.7499 102.011C92.6309 99.5068 94.3697 97.395 96.6585 96.0499C98.9473 94.7047 101.638 94.213 104.255 94.6618C106.872 95.1107 109.245 96.471 110.955 98.502C112.664 100.533 113.6 103.104 113.596 105.758C113.596 113.253 102.354 117 102.354 117M102.5 132H102.55M112.5 52H86.5C78.0992 52 73.8988 52 70.6901 53.6349C67.8677 55.073 65.573 57.3677 64.1349 60.1901C62.5 63.3988 62.5 67.5992 62.5 76V128C62.5 136.401 62.5 140.601 64.1349 143.81C65.573 146.632 67.8677 148.927 70.6901 150.365C73.8988 152 78.0992 152 86.5 152H118.5C126.901 152 131.101 152 134.31 150.365C137.132 148.927 139.427 146.632 140.865 143.81C142.5 140.601 142.5 136.401 142.5 128V82L112.5 52Z",
    stroke: "#94A3B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/EmptyState.faf6d28dbe103eedd409f750587531ee.svg";
export { ForwardRef as ReactComponent };